// extracted by mini-css-extract-plugin
export default {"alphabet__letter":"alphabet__letter__DnRig","active":"active__cXiJ4"};